import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Item = ({ label, value, important, className }) => {
    return (_jsxs("div", { className: `flex justify-between py-1 md:py-2 ${className || ''}`, children: [_jsx("div", { className: `${!important ? 'text-gray-700' : ''} ${important ? 'font-bold text-sm' : 'font-extralight text-sm'}`, children: label }), _jsx("div", { className: `${important ? 'font-bold md:text-base' : 'font-extralight md:text-base '} `, children: value })] }));
};
export default Item;
